import { Either } from "../../core/types/Either";

/**
 * The client-side session clock (PPI-1848).
 *
 * Purely local by nature: idle time is never validated server-side, so this
 * domain has no remote data source and never will. It is deliberately
 * separate from `UserRepository` because "who is signed in" and "how long has
 * this browser been untouched" change for entirely different reasons — the
 * auth service has no notion of mouse movement.
 */
export abstract class SessionRepository {
  /** Records real user input on the shared, cross-tab clock. */
  abstract touchActivity(): Promise<Either<Error, void>>;

  /** Milliseconds since the last recorded input. Fails closed. */
  abstract getIdleMilliseconds(): Promise<Either<Error, number>>;

  /**
   * Clears the activity clock only — deliberately NOT the ended reason.
   * The idle path writes the reason immediately before calling logout, so a
   * blanket clear here would erase the very message /login is about to show.
   */
  abstract clearActivity(): Promise<Either<Error, void>>;

  abstract setEndedReason(reason: string): Promise<Either<Error, void>>;

  /** Reads the ended reason and clears it, so the banner shows once. */
  abstract consumeEndedReason(): Promise<Either<Error, string>>;
}
